import React, { Component } from 'react';
import Jumbotron from '../utils/Jumbotron';
import Layout from '../header_footer/Layout';

import './noticiasEventos.css';
import NoticiaEventoSmall from './NoticiaEventoSmall';

import Masonry from 'react-masonry-component';

import axios from "axios";

class NoticiasEventos extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      noticias: []
    }

  }

  componentDidMount = () => {
    this.loadNoticias();
  }

  loadNoticias = async () => {

    let res = {};
    try {
      res = await axios.get("/api/noticiasEventos", {
        params: {
          'limit': 0
        },
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let noticias = res.data.arrayNoticiaEventos;

    this.setState({ noticias: noticias });

  }

  render() {

    const items = this.state.noticias.map(function(item){
      return <NoticiaEventoSmall item={item} key={item.title}></NoticiaEventoSmall>;
    });

    return (
      <Layout>
        <Jumbotron title={"Notícias, Projetos e Eventos"}></Jumbotron>
        <div className="container">
        <Masonry
          className={"row"}
          elementType={"div"}
          options={{transitionDuration: 0}}
        >
          {this.state.noticias.length && 
            items
          }
          
        </Masonry>
        
            
        
        </div>
      </Layout>
    )
  }
}

export default NoticiasEventos;
